import type { Quiz } from '@/types/quiz';

export function QuizStatusBadge({ status }: { status: Quiz['status'] }) {
  switch (status) {
    case 'PUBLISHED':
      return (
        <span className="inline-flex items-center rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-800">
          Veröffentlicht
        </span>
      );
    case 'DRAFT':
      return (
        <span className="inline-flex items-center rounded-full bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800">
          Entwurf
        </span>
      );
    case 'ARCHIVED':
      return (
        <span className="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
          Archiviert
        </span>
      );
  }
}
